import React from 'react'
import styles from './RegisterNoticeModal.module.scss'
import { set } from 'lodash'
import { useNavigate } from 'react-router-dom'
import Lottie from 'react-lottie'

const closeModal = (changeIsModalOpened) => {
	changeIsModalOpened(false)
}

const RegisterNoticeModal = ({
	setSubmitType,
	isOpen,
	changeIsModalOpened,
	onFormSubmit,
	onFinalDataSubmit,
	tourCaddie = false,
}) => {
	const navigate = useNavigate()
	const [animationData, setAnimationData] = React.useState(null)

	// 애니메이션 데이터 로드
	React.useEffect(() => {
		fetch('/images/golf-anim.json')
			.then((response) => response.json())
			.then((data) => setAnimationData(data))
			.catch((error) => console.error('애니메이션 로드 실패:', error))
	}, [])

	// Lottie 애니메이션 설정
	const defaultOptions = {
		loop: true,
		autoplay: true,
		animationData: animationData,
		rendererSettings: {
			preserveAspectRatio: 'xMidYMid slice',
		},
	}

	if (isOpen === false) {
		return null
	}

	return (
		<div className={styles.modalOverlay}>
			<div className={styles.modalContainer}>
				<div className={styles.imageHolder}>
					{animationData ? (
						<Lottie options={defaultOptions} height={200} width={200} />
					) : (
						<div>로딩 중...</div>
					)}
				</div>
				<div className={styles.textBox}>
					<div className={styles.text1}>가입 대기 신청이 완료됐어요</div>
					<div className={styles.text2}>
						입력하신 휴대폰 번호로
						<br />
						가입 승인 현황을 알려드려요
					</div>
				</div>
				<button
					className={styles.closeModalBtn}
					onClick={() => {
						changeIsModalOpened(false)
						navigate('/')
					}}
					type="submit">
					확인
				</button>
			</div>
		</div>
	)
}

export default RegisterNoticeModal
